<template>
  <div>
    <BasePaginationNumbers
      :class="{'hidden lg:flex': mobile !== 'numbers', 'lg:hidden': desktop !== 'numbers'}"
      v-bind="{size, page: displayPage, hasNext, hasPrev, sideDotSize, hideArrows}"
      @page-change="change"
      @next="next"
      @prev="prev"
    />

    <BasePaginationArrows
      :class="{'hidden lg:flex': mobile !== 'arrows', 'lg:hidden': desktop !== 'arrows'}"
      v-bind="{size, page: displayPage, hasNext, hasPrev}"
      @next="next"
      @prev="prev"
    />

    <BasePaginationBar
      :class="{'hidden lg:flex': mobile !== 'bar', 'lg:hidden': desktop !== 'bar'}"
      v-bind="{size, page: displayPage}"
    />
  </div>
</template>

<script setup lang="ts">
export type PaginateType = 'numbers' | 'bar' | 'dots' | 'arrows'

const props = withDefaults(defineProps<{
  size: number;
  page: number;
  loop?: boolean;
  sideDotSize?: number;
  hideArrows?: boolean;
  mobile?: PaginateType;
  desktop?: PaginateType;
}>(), {
  desktop: 'numbers',
  mobile: 'numbers',
  sideDotSize: undefined,
});

const emit = defineEmits<{(e: 'page-change', newIndex: number): void }>();

const hasNext = computed(() => props.loop || props.page < props.size - 1);
const hasPrev = computed(() => props.loop || props.page > 0);

const next = () => emit('page-change', props.page + 1);
const prev = () => emit('page-change', props.page - 1);
const change = (newPage: number) => {
  const diff = newPage - displayPage.value;
  emit('page-change', props.page + diff);
};

const modulo = (x, size) => ((x % size) + size) % size;
const displayPage = computed(() => modulo(props.page, props.size));
</script>
